import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTestCalculationSchema.translations.json';
import { zIsoDate } from '../../../../common/utils';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-test-calculation-schema',
);
addTranslations(translations);

export const AlgorithmTestCalculationValidFormDataSchema = z.object({
  algorithmIds: z.array(z.number()),
  valueDate: zIsoDate(() => t('validation.valueDate.required')),
  sourceDataVersionId: z.number(),
});
